import React, { useEffect, useState } from "react";
import { Card, Row, Col, Statistic } from "antd";
import { ArrowUpOutlined, ArrowDownOutlined } from "@ant-design/icons";
import useAuth from "../../../hooks/useAuth";
import { CompleteInformationModal } from "./Components/CompleteInformationModal";
import useFirmService from "../../../services/useFirmService";
import { useForm } from "antd/es/form/Form";

export const FirmHome = () => {
  const { firmAuth } = useAuth();
  const [form] = useForm();

  const [isCompleteModalOpen, setIsCompleteModalOpen] = useState(
    firmAuth.user.firm?.companyName === null
  );

  const { useCompleteFirmInformation, useGetFirm } = useFirmService();
  const {
    mutateAsync: completeFirmInformation,
    isPending: isCompleteInformationLoading,
  } = useCompleteFirmInformation();
  const { data: firm } = useGetFirm();

  useEffect(() => {}, [isCompleteModalOpen]);

  const handleCompleteInformation = async (values) => {
    // const values = form.getFieldsValue();
    console.log("values are", values);
    const requestBody = {
      companyName: values.companyName,
      address: values.address,
      taxOffice: values.taxOffice,
      taxNo: values.taxNo,

      districtId: values.district,
    };
    try {
      await completeFirmInformation(requestBody);
      setIsCompleteModalOpen(false);
    } catch (error) {
      console.log("error");
    }
  };
  return (
    <div
      style={{
        background: "white",
        borderRadius: "8px",
        border: "1px solid #e8e8e8",
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
        padding: "16px",
        marginBottom: "10px",
      }}>
      <h2>İstatistikler</h2>
      <Row gutter={16} justify={"space-evenly"}>
        <Col span={6}>
          <Card>
            <Statistic
              title="Aktif İlan Sayısı"
              value={15}
              precision={2}
              suffix={<ArrowUpOutlined />}
              style={{
                marginBottom: "16px",
                color: "black",
                fontWeight: "bold",
              }}
            />
            <Statistic
              value={280}
              precision={0}
              valueStyle={{ color: "#3f8600" }}
              suffix="%"
            />
          </Card>
        </Col>
        <Col span={6}>
          <Card>
            <Statistic
              title="Total Başvuru Sayısı"
              value={120}
              precision={2}
              prefix="$"
              suffix={<ArrowUpOutlined />}
              style={{ marginBottom: "16px" }}
            />
            <Statistic
              value={180}
              precision={0}
              valueStyle={{ color: "#3f8600" }}
              suffix="%"
            />
          </Card>
        </Col>
        <Col span={6}>
          <Card>
            <Statistic
              title="Taslak İlanlarım"
              value="14"
              suffix={<ArrowDownOutlined />}
              style={{ marginBottom: "16px" }}
            />
            <Statistic
              value={-10}
              precision={0}
              valueStyle={{ color: "#cf1322" }}
              suffix="%"
            />
          </Card>
        </Col>
      </Row>
      <CompleteInformationModal
        visible={isCompleteModalOpen}
        onSubmit={handleCompleteInformation}
        form={form}
        isLoading={isCompleteInformationLoading}
      />
    </div>
  );
};
